(function() { module.exports = this["wp"]["shortcode"]; }());